<template>
    <div class="j-input-wrap">
      <form action="" onsubmit="return false">
        <!-- number 数字输入框(正负数，可包含小数点,可能无法转换成Number类型)  -->
        <el-input v-if="type === 'number'" v-model="inputVal" oninput="value = value.replace(/[^\d\.-]/g, '')" v-bind="$attrs" v-on="$listeners" :clearable="clearable" @blur="inputVal = $event.target.value">
            <slot slot="prefix" name="prefix" /><slot slot="suffix" name="suffix" />
        </el-input>
        <!-- number 数字输入框(可输入负数，不包括小数点)  -->
        <el-input v-else-if="type === 'negative'" v-model="inputVal" oninput="value = value.replace(/[^\d\-]/g, '').replace(/\-{2,}/g, '-')" v-bind="$attrs" v-on="$listeners" :clearable="clearable" @blur="inputVal = $event.target.value">
            <slot slot="prefix" name="prefix" /><slot slot="suffix" name="suffix" />
        </el-input>
        <!-- number 小数输入框(仅可输入1位小数，小数点后两位)  -->
        <el-input v-else-if="type === 'decimal'" v-model="inputVal" oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/\D*(\d*)(\.?)(\d{0,2})\d*/,'$1$2$3').replace(/^\./g, '')" v-bind="$attrs" v-on="$listeners" :clearable="clearable" @blur="inputVal = $event.target.value">
            <slot slot="prefix" name="prefix" /><slot slot="suffix" name="suffix" />
        </el-input>
        <!-- integer 数字输入框(正数，不包括小数点)  -->
        <el-input v-else-if="type === 'integer'" v-model="inputVal" oninput="value = value.replace(/[^\d]/g, '')" v-bind="$attrs" v-on="$listeners" :clearable="clearable" @blur="inputVal = $event.target.value">
            <slot slot="prefix" name="prefix" /><slot slot="suffix" name="suffix" />
        </el-input>
        <!-- number-letter 字母和数字 -->
        <el-input v-else-if="type === 'number-letter'" v-model="inputVal" oninput="value = value.replace(/[\W]/g, '')" v-bind="$attrs" v-on="$listeners" :clearable="clearable" @blur="inputVal = $event.target.value">
            <slot slot="prefix" name="prefix" /><slot slot="suffix" name="suffix" />
        </el-input>
        <!-- password 带明文显示 -->
        <el-input v-else-if="type === 'password'"  class="j-input-password" :type="ciphertext ? 'password' : 'text'" v-model="inputVal" v-bind="$attrs" v-on="$listeners" :clearable="!eye && clearable" autocomplete="off" >
          <slot slot="prefix" name="prefix" /><slot slot="suffix" name="suffix" />
          <div v-if="eye" slot="suffix" class="j-input-password-eye-box">
            <span :class="{ 'j-input-password-eye': true, 'open': !ciphertext }" @click="ciphertext = !ciphertext" />
          </div>
        </el-input>
        <!-- text 文本框(字符无限制)  -->
        <el-input v-else-if="type === 'textarea'" v-model="inputVal" type="textarea" v-bind="$attrs" v-on="$listeners" :clearable="clearable" />
        <!-- text 文本输入框(字符无限制)  -->
        <el-input v-else type="text" v-model="inputVal" v-bind="$attrs" v-on="$listeners" :clearable="clearable" >
            <slot slot="prefix" name="prefix" /><slot slot="suffix" name="suffix" />
        </el-input>
      </form>
    </div>
</template>

<script>
    export default {
        name: "JInput",
        props: {
            clearable: {
                type: Boolean,
                default: true
            },
            eye: { // 设置type为password，可设置是否显示切换密文状态
                type: Boolean,
                default: true
            },
            type: { // [text, number, integer, number-letter, textarea, decimal, negative, password]
                type: String,
                default: 'text',
            },
            value: {
                required: true
            }
        },
        created () {
            this.inputVal = this.value || ''
        },
        data() {
            return {
                inputVal: '',
                ciphertext: true
            }
        },
        watch: {
            value (nv) {
                this.inputVal = nv
            },
            inputVal (nv) {
                this.$emit('input', nv)
            }
        }
    }
</script>

<style lang="scss">
    .j-input-wrap {
        .j-input-password {
            .el-input__inner {
                padding-right: 60px;
            }
        }
        .j-input-password-eye-box {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 30px;
            .j-input-password-eye {
                display: inline-flex;
                height: 20px;
                width: 100%;
                background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADEklEQVRoQ+2VT4hNYRjGn/e7o4wkNixYoCYaImt1z3nPdTczTFIW1CwITexEpDSTbEwpK0JiMU1iJdwFc893zslaxJAs/E1hpXDTdL5Xp86ta2LOueec0tS5y/ne5/e9z/N8cy9hnn9onu+P0sD/brBsoGwgZwLlE8oZYG552UDuCHMCygZyBphbXjaQO8KcgFQNaK1XMfPHnHellgdB0B+G4Xtm/p4kSjQQBMGmMAyfAphg5uEkYN7zRqOxpLe31wewgJk3JvESDUQArfUjAFsBnGbms0nQPOeu644T0XERGXcc50QSK5UB3/eHjDF3IphSaq1lWW+SwFnOPc+ri8gDIrpr2/ZQGkYqAxHIdd1rRLRfRD45jrMyDbzbGa21xJphZp5Io09tIDbxg4gWAXjVarU2DwwM/EpzSdKM7/uOMaYZzYnIFyJaDmCEmS8naVMbaDabY0qp0Q7gO2PMrlqt9jjpkrnOXdc9SkTn4+VPKKXeiMitWHOSmc/NpU9lQGsdLT4Wg9aIyDARnRGRn0qpYzMzM5P1ev1bN0Z83+8zxuzt4B5g5msRw/O83R0mtjDzk3+xEw10wpRSg5ZlNSJYs9k8qJS6EoM/A7iulJq0LOvZXEaCIKhFi4tItPxCEXkP4LDjOPc7dVrr7QBWtE1lNqC1tgGMEtFF27Zvd4KmpqY2VSqVGwC2dPz9JYAXxpjnlUplWkSqItICsIGI+gGsjmdfA+gDcI+Zd3TTXudsYgNzgbXWSwF8ALCYiE6JyCCAaMll/9C9BTAd/yjedF33HhENEtEh27avZjGR18AIgEsA7jDzzvYC0fsWkfXGmAtEtFZEjvT09NyuVqtfZz2TbQAeAnjHzO1muvKR14AGED2xPcx8c/bNWuv2OTOz97fNtNbXo2cVDXS1eTycy4DneXvCMFxXq9Xa31B/7JDGQJalC/sfSLo8/vqN0t2XNJv1PFcDWS8tUlcaKDLNLKyygSypFakpGygyzSyssoEsqRWpKRsoMs0srLKBLKkVqSkbKDLNLKyygSypFamZ9w38BqJCEEACfhEUAAAAAElFTkSuQmCC");
                background-size: cover;
                background-position: center 40%;
                background-repeat: no-repeat;
                cursor: pointer;
                &.open {
                    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEdUlEQVRoQ+1YTWhcVRT+zn0ZSZYuQqtGtIUYBMVFFSIkM+++zEhcaBXtgGICsRoR7UKKuBBcioi4kFaoliozopiioiIiybw7M9EYsEIX/qFttVb8IajbZH7ukTu8F4Yw834ymUrgPRiY4Z3z3fOd33uGsMsf2uX2IyHwf0cwiUASgR49kKRQjw7sWT2JQM8u7BEgiYDvQKVUlpn3E9F+AJsfZmYi+gnAOWa+QEQXAVyUUi716PyWek8RWFhYsIaHh2cAzAKQMQ1SAApra2vFfD7fjKm7Kb4tAqurq3vW19dnmdkYflPLE0Q1Zv6MiM553v7Osqxva7WatixrlIhGAYwy8w3MPEFE13hWfENEhcHBwcL4+PhfcYnEJqCUmgBwEsCYd9glIirW6/W3crnc91EMqFarw1rrOa31w0TUwmHm8wCOOo7zYRQMXyYWgVKpdK8Q4n1P+Swzv5FKpYqTk5P/xjnUl11ZWRmq1WpzzPy4H0lmftZxnOej4kUmoJQ6CuAlD/j4xsbGc9PT0/9EPShIrlKp7NNavw5gypM7KaV8NAp2JAJKqU8BTHu5/qBt2+8EgbuuOy+EmGDmSU9nWWv9ueM4rwXplcvlt5n5AU9mSUqZCyMRSkAp9QyAFwxQo9G4LpfL/RoEqpQ6A+BAF5mvpZS3hpA4wsyvGBnLsu5Pp9PvBckHEqhUKqNa6x+9IptwHOeLEOMXABzyvJ5vNBpV831gYCDNzOadeU5LKfNBOKVSaU4IccrIDA0N7Q3qToEElFJlAJmIh84IIQrmUCllR1ylFJv3WuvZqampYkgampZ8B4A3pZRz3WS7EnBd92kiejHIoHZQpVTL+0KIg5lM5qNOB1Yqlbu11qZNhkbB6PuEATwppTzeCbMrAaWUmZQ2EeVt2z4dVkxKqUsARizLujqdTv/RSb5arV7VbDZ/B/CblPLaMMxyuXzIS72ylLLjpA8lIIS4L5PJ+L2/65lKqZ8BXN9sNvdms9mOE3VpaWmPZVl/AvhFSrkvjIBS6h4AHwCIT6AthdabzeZINpv9O6R7FJh5JihivkfN5LZt21xDAp+eUsjLwVYRE9Ep27YPhxTdPBGdiFLEzPxYhJlwgpnnt13ExpAtbfQJx3FeDWmjmzPAFDMRfWXkmfk2r3jNz9BZ4LruASIyWL21US8Km4NMCHE4k8m0+nO3x+9GXd6Hdh/XdW8horNGv+dB5hvRfpWIctkqlUpmJtwF4HYP40ut9ccRev/LRPSUp7MzV4k2Eu2XuWNSyiNhRRj1vVJqhJmPEdFBT2dnL3O+Ie3XaWb+xHQTKeW7UQ3dKre8vHxlvV43nesRADd79dKf63RbJLYuNGeYuRhnL1hcXLwxlUo9ZNougNZAuywLjU+i00oJwEziVQAXtNbnhRBmO/vBM85sXWNCiDFmHiOiO5n5Cg/v8q6U7Wmwa5f6Tjm/K/9W2W7x7qRe6Ea2k4f1Aysh0A+vxsFMIhDHW/2QTSLQD6/GwUwiEMdb/ZBNItAPr8bB/A/i+hZPUBUmJwAAAABJRU5ErkJggg==");
                }
            }

        }
    }
</style>
